//const URL_BASE = 'http://pedraza220.dyndns.org:5050/margaritan/php/servicios';
//const URL_BASE =  'http://pedrazaviajes.dyndns.org:5555/margaritan/php/servicios';//PRODUCCION VIEJO 2023
//const URL_BASE = 'https://pedraza.com.ar/margaritaWeb/php/servicios'; //ACTUAL - 10/05/2024
const URL_BASE = 'https://estanciamargarita.com.ar/backend/php/servicios';
//const URL_BASE = 'http://localhost:3000/firsdata/pedraza/margaritan/php/servicios';



// RUTAS FIJAS //
//DESARROLLO:
//const RUTA_IMAGEN = 'http://localhost:3000/images/fancys/';
const RUTA_IMAGEN = 'https://estanciamargarita.com.ar/images/fancys/';
export { URL_BASE, RUTA_IMAGEN };
